import { createSlice, configureStore } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: 'notification', // Nom de votre slice
  initialState: [], // Initialisation avec un tableau vide
  reducers: {
    setTaxe: (state, action) => {
      return action.payload; // Utilisez les données pour mettre à jour l'état
    },
    addNotify: (state, action) => {
      const newItem = action.payload;
      const existingItemIndex = state.findIndex(item => item.key === newItem.key);
      if (existingItemIndex === -1) {
        state.push(newItem);
      }
    },
   
  },
});

export const {addNotify, setTaxe} = notificationSlice.actions

export const store = configureStore({
  reducer: {
    notification: notificationSlice.reducer,
  }
})
